// Per-project categorisation memory.
// Maps a normalised bank-statement description to the contra account it was
// posted to, so repeat transactions are categorised locally and skip the
// categorisation call entirely. Rules are learned from what the user actually posts
// (including any manual corrections), so accuracy improves over time.

// Normalise a description for matching: drop amounts/dates/reference numbers
// and punctuation so "POS PURCHASE 1234 SHELL 5512" and "POS PURCHASE SHELL"
// collapse to the same key.
export function normDesc(s) {
  return String(s || "")
    .toLowerCase()
    .replace(/[0-9]+/g, " ")
    .replace(/[^a-z ]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

// Build a balanced single-row journal from a saved rule — no engine call.
// Money in (amount >= 0): debit bank, credit the contra account.
// Money out (amount < 0): debit the contra account, credit bank.
export function journalFromRule(row, rule, bankCode, bankName) {
  const amt = Number(row.amount) || 0;
  const abs = Math.abs(amt);
  const bank = { accountCode: bankCode, accountName: bankName || "", dr: 0, cr: 0 };
  const contra = { accountCode: rule.accountCode, accountName: rule.accountName || "", dr: 0, cr: 0 };
  if (amt >= 0) { bank.dr = abs; contra.cr = abs; } else { contra.dr = abs; bank.cr = abs; }
  return {
    date: row.date,
    narration: row.description || rule.accountName || "",
    confidence: "rule",
    notes: "Matched from saved rule",
    fromRule: true,
    sourceRow: { description: row.description, amount: amt, balance: row.balance == null ? null : row.balance },
    lines: [bank, contra],
  };
}

// Learn rules from posted journals: for each 2-line bank journal with a single
// contra account, remember the contra for that description. Returns updated rules.
export function learnRules(rules, journals, bankCode) {
  const out = { ...(rules || {}) };
  (journals || []).forEach((j) => {
    const desc = j.sourceRow && j.sourceRow.description;
    if (!desc) return;
    const contra = (j.lines || []).filter((l) => l.accountCode && l.accountCode !== bankCode);
    if (contra.length !== 1) return; // only unambiguous single-contra lines
    const key = normDesc(desc);
    if (!key) return;
    out[key] = { accountCode: contra[0].accountCode, accountName: contra[0].accountName || "" };
  });
  return out;
}

export function ruleCount(rules) {
  return rules ? Object.keys(rules).length : 0;
}
